// Mock data for Stocks Protocol clone

export const stocks = [
  // Row 1
  { symbol: "XOM", name: "Exxon Mobil", ticker: "sXOM" },
  { symbol: "WMT", name: "Walmart", ticker: "sWMT" },
  { symbol: "VTI", name: "Vanguard Total Stock Market ETF", ticker: "sVTI" },
  { symbol: "V", name: "Visa", ticker: "sV" },
  { symbol: "UNH", name: "UnitedHealth Group", ticker: "sUNH" },
  { symbol: "TSLA", name: "Tesla", ticker: "sTSLA" },
  { symbol: "TMO", name: "Thermo Fisher Scientific", ticker: "sTMO" },
  { symbol: "SPY", name: "SPDR S&P 500 ETF Trust", ticker: "sSPY" },
  { symbol: "QQQ", name: "Invesco QQQ Trust Series 1", ticker: "sQQQ" },
  { symbol: "PM", name: "Philip Morris Intl", ticker: "sPM" },
  { symbol: "PLTR", name: "Palantir Technologies", ticker: "sPLTR" },
  { symbol: "PG", name: "Procter & Gamble", ticker: "sPG" },
  { symbol: "PFE", name: "Pfizer", ticker: "sPFE" },
  { symbol: "PEP", name: "PepsiCo", ticker: "sPEP" },
  { symbol: "ORCL", name: "Oracle", ticker: "sORCL" },
];

export const stocks2 = [
  // Row 2
  { symbol: "NVO", name: "Novo Nordisk", ticker: "sNVO" },
  { symbol: "NVDA", name: "NVIDIA", ticker: "sNVDA" },
  { symbol: "NFLX", name: "Netflix", ticker: "sNFLX" },
  { symbol: "MSTR", name: "Strategy", ticker: "sMSTR" },
  { symbol: "MSFT", name: "Microsoft", ticker: "sMSFT" },
  { symbol: "MRVL", name: "Marvell Tech", ticker: "sMRVL" },
  { symbol: "MRK", name: "Merck & Co", ticker: "sMRK" },
  { symbol: "META", name: "Meta Platforms", ticker: "sMETA" },
  { symbol: "MDT", name: "Medtronic", ticker: "sMDT" },
  { symbol: "MCD", name: "McDonald's", ticker: "sMCD" },
  { symbol: "MA", name: "Mastercard", ticker: "sMA" },
  { symbol: "LLY", name: "Eli Lilly", ticker: "sLLY" },
  { symbol: "LIN", name: "Linde", ticker: "sLIN" },
  { symbol: "KO", name: "Coca-Cola", ticker: "sKO" },
  { symbol: "JPM", name: "JPMorgan Chase", ticker: "sJPM" },
];

export const stocks3 = [
  // Row 3
  { symbol: "JNJ", name: "Johnson & Johnson", ticker: "sJNJ" },
  { symbol: "INTC", name: "Intel", ticker: "sINTC" },
  { symbol: "IBM", name: "IBM", ticker: "sIBM" },
  { symbol: "HOOD", name: "Robinhood Markets", ticker: "sHOOD" },
  { symbol: "HON", name: "Honeywell Intl", ticker: "sHON" },
  { symbol: "HD", name: "Home Depot", ticker: "sHD" },
  { symbol: "GS", name: "Goldman Sachs Group", ticker: "sGS" },
  { symbol: "GOOGL", name: "Alphabet (Class A)", ticker: "sGOOGL" },
  { symbol: "GME", name: "GameStop", ticker: "sGME" },
  { symbol: "GLD", name: "SPDR Gold Shares", ticker: "sGLD" },
  { symbol: "DHR", name: "Danaher", ticker: "sDHR" },
  { symbol: "CVX", name: "Chevron", ticker: "sCVX" },
  { symbol: "CSCO", name: "Cisco Systems", ticker: "sCSCO" },
  { symbol: "CRWD", name: "CrowdStrike Holdings", ticker: "sCRWD" },
  { symbol: "CRM", name: "Salesforce", ticker: "sCRM" },
];

export const stocks4 = [
  // Row 4
  { symbol: "COIN", name: "Coinbase Global", ticker: "sCOIN" },
  { symbol: "CMCSA", name: "Comcast", ticker: "sCMCSA" },
  { symbol: "BRK.B", name: "Berkshire Hathaway", ticker: "sBRK.B" },
  { symbol: "BAC", name: "Bank of America", ticker: "sBAC" },
  { symbol: "AZN", name: "AstraZeneca", ticker: "sAZN" },
  { symbol: "AVGO", name: "Broadcom", ticker: "sAVGO" },
  { symbol: "APP", name: "AppLovin", ticker: "sAPP" },
  { symbol: "AMZN", name: "Amazon.com", ticker: "sAMZN" },
  { symbol: "ACN", name: "Accenture", ticker: "sACN" },
  { symbol: "ABT", name: "Abbott Laboratories", ticker: "sABT" },
  { symbol: "ABBV", name: "AbbVie", ticker: "sABBV" },
  { symbol: "AAPL", name: "Apple", ticker: "sAAPL" },
];

export const features = [
  {
    title: "Dual-Chain Architecture",
    description: "Built on Stellar for speed and XRPL for liquidity. The best of both worlds in one unified protocol.",
  },
  {
    title: "3-5 Second Settlements",
    description: "No more T+2 waiting. Your trades settle in seconds, not days. True instant finality on-chain.",
  },
  {
    title: "Near-Zero Fees",
    description: "Transaction costs under $0.01. Trade frequently without worrying about fees eating your profits.",
  },
  {
    title: "24/7 Trading",
    description: "Markets never close on Stocks Protocol. Trade Apple, Tesla, or NVIDIA any time, any day.",
  },
  {
    title: "True Asset Ownership",
    description: "Your tokens, your keys. Withdraw to self-custody wallets and maintain full control of your assets.",
  },
  {
    title: "Cross-Chain Liquidity",
    description: "Seamlessly bridge assets between Stellar and XRPL ecosystems. Access deeper liquidity pools.",
  },
];

export const faqs = [
  {
    question: "What is Stocks Protocol?",
    answer: "Stocks Protocol is a Layer 1 blockchain purpose-built for tokenized stocks and ETFs. It combines Stellar's security and speed with XRPL's deep liquidity to enable instant, low-cost trading of U.S. equities globally."
  },
  {
    question: "How does the dual-chain architecture work?",
    answer: "Stocks Protocol leverages both Stellar and XRP Ledger. Stellar provides fast consensus and low fees, while XRPL offers deep liquidity and cross-border payment rails. Assets can seamlessly bridge between both networks."
  },
  {
    question: "What stocks and ETFs are available?",
    answer: "We offer 60+ tokenized assets including major stocks like Tesla (sTSLA), Apple (sAAPL), NVIDIA (sNVDA), and ETFs like SPY (sSPY) and QQQ (sQQQ)."
  },
  {
    question: "How fast are settlements?",
    answer: "Trades settle in 3-5 seconds on Stocks Protocol, compared to T+2 (2 business days) on traditional exchanges. True instant finality powered by blockchain consensus."
  },
  {
    question: "What are the fees?",
    answer: "Transaction fees are under $0.01, making frequent trading economically viable. No hidden fees, no minimum balances, no account maintenance charges."
  },
  {
    question: "Can I self-custody my tokens?",
    answer: "Yes! Stocks Protocol supports non-custodial wallets. Withdraw your stock tokens to any compatible Stellar or XRPL wallet and maintain full control of your assets."
  },
  {
    question: "Is Stocks Protocol available worldwide?",
    answer: "Stocks Protocol is accessible from 150+ countries. As a decentralized protocol, it removes traditional brokerage barriers and geographic restrictions."
  },
  {
    question: "How are tokens backed?",
    answer: "Each stock token is backed 1:1 by real shares held in regulated custody. Reserve attestations are published regularly for full transparency."
  },
  {
    question: "Can I trade 24/7?",
    answer: "Yes! Unlike traditional markets with limited hours, Stocks Protocol enables round-the-clock trading. Buy Apple at midnight or sell Tesla on Sunday."
  },
  {
    question: "How do I get started?",
    answer: "Connect your Stellar or XRPL wallet, fund with USDC/XLM/XRP, and start trading instantly. No lengthy KYC for basic access, no minimum deposits required."
  },
  {
    question: "Is Stocks Protocol secure?",
    answer: "Built on battle-tested Stellar and XRPL infrastructure with billions in daily volume. Smart contract audits, multi-sig treasury, and insurance coverage protect user assets."
  },
];

export const articles = [
  {
    title: "Introduction to Stocks Protocol L1",
    duration: "8 min",
    link: "/learn/introduction-to-stocks-protocol"
  },
  {
    title: "Stellar vs XRPL: Why We Use Both",
    duration: "12 min",
    link: "/learn/stellar-vs-xrpl"
  },
  {
    title: "How Tokenized Stocks Work",
    duration: "10 min",
    link: "/learn/how-tokenized-stocks-work"
  },
  {
    title: "Self-Custody Guide for Stock Tokens",
    duration: "7 min",
    link: "/learn/self-custody-guide"
  },
  {
    title: "Understanding Settlement Times",
    duration: "5 min",
    link: "/learn/understanding-settlement-times"
  },
  {
    title: "Getting Started with Stocks Protocol",
    duration: "15 min",
    link: "/learn/getting-started"
  },
];
